import { Button } from 'component/Button'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'

type Props = {
  onUpload: () => void
}

export const UploadButton = observer(({ onUpload }: Props) => {
  return (
    <Button
      text
      flat
      wide
      upper
      large={opt.basic}
      action={onUpload}
    >
      {i18n('UploadSelfie')}
    </Button>
  )
})
